import { render, staticRenderFns } from "./ExemptionForm.vue?vue&type=template&id=4eb6a77c"
import script from "./ExemptionForm.vue?vue&type=script&lang=js"
export * from "./ExemptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports